var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrescriptionIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14784_230149)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1862 6.66667L25.3328 10.7733H18.6662L25.3328 3.70667V3.44C25.3116 2.7766 25.4889 2.12196 25.842 1.55995C26.1951 0.997935 26.708 0.55414 27.3149 0.285414C27.9218 0.0166878 28.5952 -0.0647316 29.2486 0.0515856C29.9021 0.167903 30.506 0.47666 30.9829 0.938304C31.4598 1.39995 31.788 1.99346 31.9255 2.6428C32.063 3.29214 32.0035 3.96775 31.7547 4.58308C31.5058 5.19841 31.0789 5.72543 30.5287 6.09664C29.9785 6.46784 29.3299 6.66633 28.6662 6.66667C28.5062 6.68 28.3462 6.68 28.1862 6.66667ZM31.9995 13.44V16.1067L29.3328 25.44L31.9995 34.7733V37.44H7.99951V34.7733L11.9995 25.44L7.99951 16.1067V13.44H31.9995Z",
    fill: "#11723B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14784_230149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrescriptionIcon);
export default __webpack_public_path__ + "static/media/prescriptionIcon.695713bb62b96a46ce9bbfce1fd12d47.svg";
export { ForwardRef as ReactComponent };